import { defineAction } from '~/prix'
import { z } from 'zod'
import creditDocumentUpdateAction from './creditDocumentUpdate.action.json' with { type: 'json' }
import { creditDocumentUpdateInputObject } from '../creditDocumentObject'

const creditDocumentUpdateDefinition = defineAction({
  ...creditDocumentUpdateAction,

  input: creditDocumentUpdateInputObject,
  output: z.object({}),
})

export default creditDocumentUpdateDefinition

